<template>
  <div :id="id" class="animation" />
</template>

<script>
import lottie from 'lottie-web';

export default {
  name: 'AnimatedIcon',
  props: {
    path: {
      type: String,
      required: true,
    },
    loop: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const id = `icon-${Math.random().toString(36).substr(2, 9)}`;
    return { id, animation: null };
  },
  watch: {
    path() {
      this.loadAnimation();
    },
  },
  mounted() {
    this.loadAnimation();
  },
  beforeDestroy() {
    this.destroyAnimation();
  },
  methods: {
    loadAnimation() {
      this.destroyAnimation();
      this.animation = lottie.loadAnimation({
        container: document.getElementById(this.id),
        renderer: 'svg',
        loop: this.loop,
        autoplay: true,
        path: this.path,
      });

      this.animation.addEventListener('complete', () => this.$emit('complete'));
    },
    destroyAnimation() {
      if (this.animation) {
        this.animation.destroy();
      }
    },
  },
};
</script>

<style scoped>
 .animation {
    overflow: hidden;
    transform: translate3d(0,0,0);
    text-align: center;
    opacity: 1;
 }
</style>
